import {
  FETCH_START,
  FETCH_ERROR,
  FETCH_SUCCESS,
  SHOW_MESSAGE,
  DB_LIST_CLIENTS,
  DB_GET_CLIENT,
  DB_CLIENTS_ORG,
  DB_AUTOCOMPLETE_CLIENT,
  CURR_CTAGS,
  UPDATE_SEARCH_CTAGS,
  DB_AUTOCOMPLETE_CTAG,
  GET_ALL_CTAGS,
} from "constants/ActionTypes"

import {
  notification
} from 'antd'

import axiosDB from 'util/ApiDB'

import setupAxiosInterceptors from "appRedux/actions/setupAxiosInterceptors";

import { surveyUserSignIn } from 'appRedux/actions/Auth'
import ApiDBLimesurvey from 'util/ApiDBLimesurvey'

import { 
  ActionAssessmentsListClientsReset,
  ActionAssessmentsListClients
} from 'appRedux/actions/Clients/Tabs/Assessments';

export const ActionClientsList = () => {
  return (dispatch, getState) => {
    dispatch({type: FETCH_START})

    const request = setupAxiosInterceptors(axiosDB, dispatch, getState);

    request.get('client/list').then(({data}) => {
      /*
      const clients = data.response.clients.map(item => {
        return {
          id: item.id,
          firstname: item.firstname,
          lastname: item.lastname,
          email: item.email
        }
      });
      */
      const clients = data.response.clients;
      
      const stateUpdateClients = (clients, dispatch) => new Promise((resolve, reject) => {
        dispatch({type: DB_LIST_CLIENTS, payload: {clients: clients}})
        resolve()
      })

      stateUpdateClients(clients, dispatch).then(()=>{
        dispatch({ type: FETCH_SUCCESS });
      })
      
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
  }
}

export const ActionClientsGet = (cid) => {
  return (dispatch, getState) => {
    dispatch({type: FETCH_START})

    const request = setupAxiosInterceptors(axiosDB, dispatch, getState);

    request.get('client/' + cid).then(({data}) => {
      dispatch({type: DB_GET_CLIENT, payload: {
        client: data.response.client
      }})
      
      /*
      dispatch({
        type: CURR_CTAGS, payload: {
          tags: data.response.client.tags
        }
      })
      dispatch(getAllCTags())
      */
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
  }
}

export const ActionSyncResponsesByClient = (cid) => {
  return (dispatch, getState) => {
    dispatch({type: FETCH_START})
    const { limesurvey_session_key } = getState().authSurvey;

    const request = setupAxiosInterceptors(ApiDBLimesurvey, dispatch, getState);

    request.post('sync-responses', {
      'sSessionKey': limesurvey_session_key,
      'cid': cid
    }).then(({ data }) => {
      //console.log(data)
      dispatch(ActionAssessmentsListClientsReset())
      dispatch(ActionAssessmentsListClients(cid))
      setTimeout(() => {
        
      }, 5000);
    }).catch(function (error) {
      if(error.response.data.message) {
        dispatch({ type: FETCH_ERROR, payload: error.response.data.message });

        if(error.response.data.message.toLowerCase() === 'invalid session key') {
          localStorage.removeItem("limesurvey_session_key");
          dispatch(surveyUserSignIn()).then(() => {
            dispatch(ActionSyncResponsesByClient(cid))
          })
        }
        
      } else {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      }
    });
  }
}

export const ActionClientsAdd = (formData) => {
  return (dispatch, getState) => {
    dispatch({type: FETCH_START})

    const request = setupAxiosInterceptors(axiosDB, dispatch, getState);

    request.post('client/add', {
      formData: formData
    }).then(({data}) => {
      dispatch(ActionClientsList());
      dispatch(ActionAssessmentsListClientsReset());
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
  }
}

export const ActionClientsAddByCsv = (formData) => {
  return (dispatch, getState) => {
    dispatch({type: FETCH_START})

    const request = setupAxiosInterceptors(axiosDB, dispatch, getState);

    let newFormData = new FormData();
    
    newFormData.append('organisation', formData.organisation);
    formData.file[0].originFileObj ?
    newFormData.append("file", formData.file[0].originFileObj) : newFormData.append("file", formData.file[0])

    request.post('client/addbycsv', newFormData).then(({data}) => {
      
      if(data.response.error[0] !== 'null'){
        console.log(data.response.error)
        let error = '';
        for(var err in data.response.error){
          error = error+"Client "+err+': '+data.response.error[err]+". ";
        }
        // let error2 = (<div>
        //   {data.response.error.map((key,value)=>
        //   <p>Client {key}: {value}.</p>)}
        // </div>)
        let args = {
          message: 'Error',
          description:
            error,
          duration: 0,
        };
        notification.open(args);
        dispatch({type: FETCH_ERROR, payload: ''});
        console.log("Error****:", error);
      }
      
      if(data.response.success[0] !== 'null'){
        let success = 'Client ';
        for(var suc in data.response.success){
          success = success+data.response.success[suc]+' ';
        }
        success = success + "create successfully."

        dispatch({type: SHOW_MESSAGE, payload: success});
        dispatch(ActionClientsList());
      }
      
      
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
  }
}


export const ActionClientsReset = () => {
  return (dispatch) => {
    dispatch({type: DB_GET_CLIENT, payload: {client: null}})
  }
}

export const ActionClientsUpdate = (formData) => {
  return (dispatch, getState) => {
    dispatch({type: FETCH_START})

    const {db_client} = getState().clients.client_ui;
    
    const request = setupAxiosInterceptors(axiosDB, dispatch, getState);

    request.post('client/' + db_client.id + '/update', {
      formData: formData
    }).then(({data}) => {      
      dispatch(ActionClientsList());
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
  }
}

export const ActionClientsDelete = (cid) => {
  return (dispatch, getState) => {
    dispatch({type: FETCH_START})

    const request = setupAxiosInterceptors(axiosDB, dispatch, getState);

    request.post('client/' + cid + '/delete', {}).then(({data}) => {
      dispatch(ActionClientsList());
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
  }
}

export const ActionClientsByOrganisation = (oid) =>{
  return (dispatch, getState) => {
    dispatch({type: FETCH_START})

    const request = setupAxiosInterceptors(axiosDB, dispatch, getState);

    request.get('client/' + oid + '/orgainsation').then(({data}) => {
      dispatch({type: DB_CLIENTS_ORG, payload: {
        clients: data.response.clients
      }})
      dispatch({ type: FETCH_SUCCESS })
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
  }
}

export const ActionAutocompleteClients = (value) =>{
  return (dispatch, getState) => {
    
    const request = setupAxiosInterceptors(axiosDB, dispatch, getState);

    request.post('client/autocomplete', {
      term: value
    }).then(({data}) => {      
      dispatch({type: DB_AUTOCOMPLETE_CLIENT, payload: {clients: data.response.clients}});
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
  }
}

export const updateCTagsInPage = (tags) => {
  return (dispatch) => {
    dispatch({
      type: CURR_CTAGS, payload: {
        tags: tags
      }
    })
  }
}

export const updateCTagsSearchResult = (tags) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_SEARCH_CTAGS, payload: {
        tags: tags
      }
    })
  }
}

export const ActionAutocompleteCTags = (value) =>{
  return (dispatch, getState) => {
    
    const request = setupAxiosInterceptors(axiosDB, dispatch, getState);

    request.post('client/ctag_autocomplete', {
      term: value
    }).then(({data}) => {      
      dispatch({type: DB_AUTOCOMPLETE_CTAG, payload: {tags: data.response.tags}});
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
  }
}

export const getAllCTags = () => {
  return (dispatch, getState) => {
    dispatch({ type: FETCH_START })

    const request = setupAxiosInterceptors(axiosDB, dispatch, getState);

    request.get('client/allctags').then(({ data }) => {
      dispatch({ type: FETCH_SUCCESS });
      dispatch({
        type: GET_ALL_CTAGS, payload: {
          tags: data.response.tags
        }
      })
    }).catch(function (error) {
      dispatch({ type: FETCH_ERROR, payload: error.message });
      console.log("Error****:", error.message);
    });
  }
}

export const saveClientTags = (cid, tags) => {
  return (dispatch, getState) => {
    const request = setupAxiosInterceptors(axiosDB, dispatch, getState);

    request.post('client/' + cid + '/tags', {
      tags: tags
    }).then(({ data }) => {     
      dispatch(resetCTagsUI());
    }).catch(function (error) {
      dispatch({ type: FETCH_ERROR, payload: error.message });
      console.log("Error****:", error.message);
    });
  }
}

export const resetCTagsUI = () => {
  return (dispatch) => {
    // Reset UI
    // dispatch({
    //   type: GET_SURVEY, payload: {
    //     survey: null
    //   }
    // })
    dispatch({
      type: CURR_CTAGS, payload: {
        tags: []
      }
    })
  }
}